// Variable naming convention
// [component] + Styles + [Section] + [Variation]
// Styles split into sections of 'DefaultTheme', 'DarkTheme', 'Structure', and 'Typography'
// Examples: accordionStylesStructureWide or buttonStylesDarkThemePrimary

export const checkboxStylesDefaultTheme = [
	{
		name: 'Text',
		property: 'color',
		value: '081826',
		isColorTile: true,
	},
	{
		name: 'Text: hover',
		property: 'color',
		value: '1771c6',
		isColorTile: true,
	},
	{
		name: 'Text (selected)',
		property: 'color',
		value: '081826',
		isColorTile: true,
	},
	{
		name: 'Container',
		property: 'background-color',
		value: 'f4f5f7',
		isColorTile: true,
	},
	{
		name: '',
		property: 'border-color',
		value: '1f2a37',
		isColorTile: true,
	},
	{
		name: 'Container: hover',
		property: 'background-color',
		value: 'f4f5f7',
		isColorTile: true,
	},
	{
		name: '',
		property: 'border-color',
		value: '1771c6',
		isColorTile: true,
	},
	{
		name: 'Container: focus',
		property: 'border-color',
		value: '1771c6',
		isColorTile: true,
	},
	{
		name: '',
		property: 'outline-color',
		value: 'FF8040',
		isColorTile: true,
	},
	{
		name: 'Container (selected)',
		property: 'background-color',
		value: '1c63a5',
		isColorTile: true,
	},
	{
		name: '',
		property: 'border-color',
		value: '1c63a5',
		isColorTile: true,
	},
	{
		name: 'Container (selected): hover',
		property: 'background-color',
		value: '1771c6',
		isColorTile: true,
	},
	{
		name: '',
		property: 'border-color',
		value: '1771c6',
		isColorTile: true,
	},
	{
		name: 'Container (selected): focus',
		property: 'background-color',
		value: '1771c6',
		isColorTile: true,
	},
	{
		name: '',
		property: 'border',
		value: '1771c6',
		isColorTile: true,
	},
	{
		name: 'Checkmark (selected)',
		property: 'background-color',
		value: 'FFFFFF',
		isColorTile: true,
	},
	{
		name: 'Checkmark (selected): hover',
		property: 'background-color',
		value: 'FFFFFF',
		isColorTile: true,
	},
	{
		name: 'Checkmark (selected): focus',
		property: 'background-color',
		value: 'FFFFFF',
		isColorTile: true,
	},
	{
		name: 'Text (supporting content)',
		property: 'color',
		value: '15293A',
		isColorTile: true,
	}
];

export const checkboxStylesDarkTheme = [
	{
		name: 'Text',
		property: 'color',
		value: 'fcfcfc',
		isColorTile: true,
	},
	{
		name: 'Text: hover',
		property: 'color',
		value: '7cc3fd',
		isColorTile: true,
	},
	{
		name: 'Text (selected)',
		property: 'color',
		value: 'fcfcfc',
		isColorTile: true,
	},
	{
		name: 'Container',
		property: 'background-color',
		value: '121212',
		isColorTile: true,
	},
	{
		name: '',
		property: 'border-color',
		value: '949494',
		isColorTile: true,
	},
	{
		name: 'Container: hover',
		property: 'background-color',
		value: '121212',
		isColorTile: true,
	},
	{
		name: '',
		property: 'border-color',
		value: '7cc3fd',
		isColorTile: true,
	},
	{
		name: 'Container: focus',
		property: 'border-color',
		value: '7cc3fd',
		isColorTile: true,
	},
	{
		name: '',
		property: 'outline-color',
		value: 'FF8040',
		isColorTile: true,
	},
	{
		name: 'Container (selected)',
		property: 'background-color',
		value: '53b1fd',
		isColorTile: true,
	},
	{
		name: '',
		property: 'border-color',
		value: '53b1fd',
		isColorTile: true,
	},
	{
		name: 'Container (selected): hover',
		property: 'background-color',
		value: '7cc3fd',
		isColorTile: true,
	},
	{
		name: '',
		property: 'border-color',
		value: '7cc3fd',
		isColorTile: true,
	},
	{
		name: 'Container (selected): focus',
		property: 'background-color',
		value: '7cc3fd',
		isColorTile: true,
	},
	{
		name: '',
		property: 'border',
		value: '7cc3fd',
		isColorTile: true,
	},
	{
		name: 'Checkmark (selected)',
		property: 'background-color',
		value: '081826',
		isColorTile: true,
	},
	{
		name: 'Checkmark (selected): hover',
		property: 'background-color',
		value: '081826',
		isColorTile: true,
	},
	{
		name: 'Checkmark (selected): focus',
		property: 'background-color',
		value: '081826',
		isColorTile: true,
	},
	{
		name: 'Text (supporting content)',
		property: 'color',
		value: 'E7E9E9',
		isColorTile: true,
	}
];

export const checkboxStylesTypographyAll = [
	{
		name: 'Text',
		property: 'font-family',
		value: '"Inter Regular", sans-serif',
		isColorTile: false,
	},
	{
		name: '',
		property: 'font-size',
		value: '0.875rem',
		isColorTile: false,
	},
	{
		name: '',
		property: '',
		value: '14px',
		isColorTile: false,
	},
	{
		name: '',
		property: 'font-weight',
		value: 'regular / 400',
		isColorTile: false,
	},
	{
		name: '',
		property: 'line-height',
		value: '1.25rem',
		isColorTile: false,
	},
	{
		name: '',
		property: '',
		value: '20px',
		isColorTile: false,
	},
];

export const checkboxStylesTypographySupporting = [
	{
		name: 'Text',
		property: 'font-family',
		value: '"NotoSans Regular", sans-serif',
		isColorTile: false,
	},
	{
		name: '',
		property: 'font-size',
		value: '0.75rem',
		isColorTile: false,
	},
	{
		name: '',
		property: '',
		value: '12px',
		isColorTile: false,
	},
	{
		name: '',
		property: 'font-weight',
		value: 'regular / 400',
		isColorTile: false,
	},
	{
		name: '',
		property: 'line-height',
		value: '1.125rem',
		isColorTile: false,
	},
	{
		name: '',
		property: '',
		value: '18px',
		isColorTile: false,
	},
];

export const checkboxStylesStructureAll = [
	{
		name: 'Text (label)',
		property: 'margin-left',
		value: '8px',
		isColorTile: false,
	},
	{
		name: 'Text (supporting)',
		property: 'margin-top',
		value: '4px',
		isColorTile: false,
	},
	{
		name: 'Outline: focus',
		property: 'weight',
		value: '2px',
		isColorTile: false,
	},
	{
		name: '',
		property: 'offset',
		value: '2px',
		isColorTile: false,
	},
];

export const checkboxStylesStructureSupporting = [
	{
		name: 'Supporting Text',
		property: 'margin-left',
		value: '26px',
		isColorTile: false,
	},
];
